import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Dialog, { DialogContent } from 'xpi-black-ui/Common/Dialog';
import { SomaButton } from '@soma/react';
import waConfig from '../../../utils/waConfig';
import { useCMSModal } from '../../../hooks/useCMSModal';
import { useNotificationContext } from '../../../state/notification';
import { SET_OPEN } from '../../../state/notification/types';

import { BlackDialogHeader, Container, Paragraph, Text, Modal, NotificationContainerButton } from './styles';
import useProposal from 'store/Proposals/state';

const CMSModal = ({ notificationDispatch }) => {
  const { isSendingPush, sendProposals, currentProposal } = useProposal();
  const [preventRedirect, setPreventRedirect] = useState(false);
  const history = useHistory();
  const cmsModalContext = useCMSModal();

  const navigateTo = pathname => history.push(pathname);

  const handleOnCloseModal = () => {
    cmsModalContext.closeModal();

    setTimeout(() => {
      if (
        !preventRedirect
        && (cmsModalContext.isInCustodyModal || cmsModalContext.isInStructurePopModal)
      ) {
        navigateTo('/');
      }
    }, 100);

    setPreventRedirect(false);
  };

  const handleForOpenTimeLimitModal = (routePathname) => {
    const isOperationRoute = routePathname.includes('operacao');

    if (!isOperationRoute && cmsModalContext.isInCustodyModal) {
      cmsModalContext.closeModal();
    }
  };

  useEffect(() => handleForOpenTimeLimitModal(history.location.pathname), []);
  useEffect(() => history.listen(location => handleForOpenTimeLimitModal(location.pathname), [history]));

  return (
    <Modal
      size="md"
      open={cmsModalContext.isOpened}
      preventScroll
      defaultClose={false}
      onSomaModalOpen={() => handleForOpenTimeLimitModal(history.location.pathname)}
      onSomaModalClose={() => handleOnCloseModal()}
    >
      <BlackDialogHeader title={cmsModalContext.title} onClose={() => handleOnCloseModal()} />
      <DialogContent>
        <Container>
          <Paragraph>
            {cmsModalContext?.content?.map((text, index) => (
              <Text key={index.toString()}>{text}</Text>
            ))}
          </Paragraph>

          {cmsModalContext.isNotification
            && (
              <NotificationContainerButton>
                <SomaButton
                  size="sm"
                  variant="primary"
                  onClick={() => {
                    notificationDispatch({
                      type: SET_OPEN,
                      payload: true,
                    });
                    cmsModalContext.closeModal();
                  }}
                  aria-label={waConfig.event.cmsModal.buttonAcceptTerm}
                  style={{ width: '250px' }}
                >
                  Clique aqui para conhecer
                </SomaButton>
              </NotificationContainerButton>
            )}

          {(cmsModalContext.isInCustodyModal || cmsModalContext.isInStructurePopModal) && (
            <SomaButton
              size="lg"
              variant="secondary"
              onSomaClick={() => {
                setPreventRedirect(true);
                if (cmsModalContext.isInStructurePopModal && isSendingPush) {
                  sendProposals(currentProposal);
                }
                cmsModalContext.closeModal();
              }}
              aria-label={waConfig.event.cmsModal.buttonAcceptTerm}
              style={{ width: '100%' }}
            >
              ESTOU DE ACORDO
            </SomaButton>
          )}
        </Container>
      </DialogContent>
    </Modal>
  );
};

export default CMSModal;
